// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Kp6ONDeDcacnfmjRQXGF{position:absolute;left:-24px;bottom:5px}.RZyPVXr0aazdj1jxszQ4{position:absolute;right:-24px;bottom:5px}", "",{"version":3,"sources":["webpack://./src/templates/instructions/chat-bubble-tip.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CACA,UAAA,CACA,UAAA,CAGF,sBACE,iBAAA,CACA,WAAA,CACA,UAAA","sourcesContent":[".svgLtr {\n  position: absolute;\n  left: -24px;\n  bottom: 5px;\n}\n\n.svgRtl {\n  position: absolute;\n  right: -24px;\n  bottom: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svgLtr": "Kp6ONDeDcacnfmjRQXGF",
	"svgRtl": "RZyPVXr0aazdj1jxszQ4"
};
export default ___CSS_LOADER_EXPORT___;
